import React from 'react';
import { Region } from 'types/model';

type Props = {
  regions: Region[];
};

export const DATA_QA_REGIONS_SEO = 'regions-seo';

export function RegionsSeo({ regions }: Props) {
  return (
    <div hidden data-qa={DATA_QA_REGIONS_SEO}>
      {regions?.map(({ regionName, currentPageLink }) => {
        const { origin, pathname } = new URL(currentPageLink);
        return (
          <a key={regionName} href={`${origin}${pathname}`}>
            {regionName}
          </a>
        );
      })}
    </div>
  );
}
